// The admin renders every page at this scale: `zoom` on <body> in index.css.
// Keep the two in step. 7/8, so every length on the design's 8px grid lands on
// a whole screen pixel (40px buttons show at 35px, 24px padding at 21px).
export const BODY_ZOOM = 0.875;

// The full window height in CSS px inside the body zoom (100vh is shrunk by
// the zoom like every other length), for layouts that fill the window.
export const FULL_VIEWPORT_HEIGHT = `calc(100vh / ${BODY_ZOOM})`;

// A length that lands on a whole pixel on screen after the zoom, closest to
// `px` scaled. For small SVG boxes, which Safari clips when they sit on a
// fractional pixel.
export const wholeScreenPx = (px: number) =>
  Math.round(px * BODY_ZOOM) / BODY_ZOOM;

// The scale text is shown at. Equal to BODY_ZOOM, text scales with the page
// and keeps the design's proportions (14px body text shows at 12.25px). Set it
// higher to show text bigger than the layout around it; 1 shows every size at
// its real value (as platform#341 did, with BODY_ZOOM 0.9). Keep --text-scale
// in index.css (TEXT_ZOOM / BODY_ZOOM) in step.
export const TEXT_ZOOM = BODY_ZOOM;

// A font size (or a px line height) as designed, shown at TEXT_ZOOM on
// screen. Every inline font size goes through it.
export const textPx = (px: number) => (px * TEXT_ZOOM) / BODY_ZOOM;
